import { render, staticRenderFns } from "./itemsbelongings-list.vue?vue&type=template&id=b92501da&scoped=true"
import script from "./itemsbelongings-list.vue?vue&type=script&lang=js"
export * from "./itemsbelongings-list.vue?vue&type=script&lang=js"
import style0 from "./itemsbelongings-list.vue?vue&type=style&index=0&id=b92501da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92501da",
  null
  
)

export default component.exports